export default __webpack_public_path__ + "static/media/scanIcon.2cad3586.svg";